import { ChargingStationDetailsModel } from '../chargingStationDetailsModel';
import { ChargingStationDto, CSOcppStatusDto } from '../chargingStationDto';
import { evsesRule } from '../evsesRule';

export function chargingStationDetailsNormalizer(
  chargingStationDto: ChargingStationDto
): ChargingStationDetailsModel {
  return {
    id: chargingStationDto.chargingStationId.toString(),
    csmsUuid: chargingStationDto.csmsUuid,
    serialNumber: chargingStationDto.chargingStationSerialNumber ?? 'N/A',
    identityKey: chargingStationDto.identityKey ?? 'N/A',
    firmware: chargingStationDto.firmware ?? '',
    model: chargingStationDto.chargingStationModel ?? 'N/A',
    name: chargingStationDto.chargingStationName ?? 'N/A',
    geolocation: chargingStationDto.coordinates
      ? {
          latitude: chargingStationDto.coordinates.latitude,
          longitude: chargingStationDto.coordinates.longitude,
        }
      : {
          latitude: '0',
          longitude: '0',
        },
    online: onlineStatusNormalizer(chargingStationDto.ocppStatus),
    status:
      chargingStationDto.ocppStatus === null
        ? 'PROVISIONED'
        : chargingStationDto.ocppStatus,
    evses: evsesRule(chargingStationDto.evses),
    location: locationNormalizer(chargingStationDto.locationDetails),
    username: chargingStationDto.userName ?? undefined,
    password: chargingStationDto.password ?? undefined,
    chargingStationGroupDetails: chargingStationGroupDetailsNormalizer(
      chargingStationDto.chargingStationGroupDetails
    ),
    protocol: chargingStationDto.ocppProtocol,
  };
}

const chargingStationGroupDetailsNormalizer = (chargingStationGroupDetails: {
  chargingStationGroupName: string;
  chargingStationGroupUuid: string;
}): ChargingStationDetailsModel['chargingStationGroupDetails'] => {
  if (!chargingStationGroupDetails) {
    return {
      chargingStationGroupName: undefined,
      chargingStationGroupUuid: undefined,
    };
  }

  return {
    chargingStationGroupName:
      chargingStationGroupDetails.chargingStationGroupName ?? 'N/A',
    chargingStationGroupUuid:
      chargingStationGroupDetails.chargingStationGroupUuid ?? '',
  };
};

const locationNormalizer = (locationDetails: {
  name: string;
  id: string;
}): ChargingStationDetailsModel['location'] => {
  if (!locationDetails) {
    return {
      id: undefined,
      name: undefined,
    };
  }
  return {
    id: locationDetails.id ?? '',
    name: locationDetails.name ?? 'N/A',
  };
};

function onlineStatusNormalizer(status: CSOcppStatusDto | undefined): boolean {
  if (!status) return false;

  // TBD: Could be online unless it's undefined
  const statusMap: Record<CSOcppStatusDto, boolean> = {
    AVAILABLE: true,
    CHARGING: true,
    UNDEFINED: false,
    PREPARING: false,
    OCCUPIED: false,
    SUSPENDEDEVSE: false,
    SUSPENDEDEV: false,
    FINISHING: false,
    RESERVED: false,
    UNAVAILABLE: false,
    FAULTED: false,
  };
  return statusMap[status] ?? false;
}
